/**
 * This file is created manually
 * You can change the content
 *
 */

import H from './typography/H'
export * from './typography/H'
export default H
